import useToast from '@hooks/useToast'
import { motion } from 'framer-motion'
import React, { FC } from 'react'

const Toast: FC = () => {
  const { visible, message } = useToast()

  return (
    <motion.div
      role="status"
      aria-live="polite"
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: visible ? 1 : 0, y: visible ? 0 : 40 }}
      transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
      className="pointer-events-none fixed inset-x-0 bottom-5 z-[200] flex justify-center px-4"
    >
      <div className="plug-sheet-surface rounded-pill border border-hairline bg-sheet px-4 py-2.5 text-center font-text text-[14px] font-medium text-fg shadow-md">
        {message}
      </div>
    </motion.div>
  )
}

export default Toast
